import { useMemo } from 'react';
import { faStar } from '@fortawesome/pro-regular-svg-icons';
import { FilterContainer } from 'components/filter/filters-next/FilterContainer';
import { FilterForm } from 'components/filter/filters-next/FilterForm';
import { FilterFormContext } from 'components/filter/filters-next/FilterFormContext';
import { FilterSubmit } from 'components/filter/filters-next/FilterSubmit';
import { ReadableFilterValue } from 'components/filter/filters-next/ReadableFilterValue';
import { useCurrentFilter } from 'components/filter/filters-next/useCurrentFilter';
import { useFilter } from 'components/filter/filters-next/useFilter';
import {
    ContentFilterComponent,
    DownstreamFilterTransform,
    FilterFormValue,
    FilterIcon,
    FilterValue,
    LabelFilterComponent,
    ReadableFilterComponent,
    ServerKey,
    UpstreamFilterTransform,
} from 'components/filter/types';
import * as Form from 'components/form';
import { identity } from 'lodash';

interface PrimaryAddressFilterFormValues extends FilterFormValue<string> {}

export const filterKey: ServerKey = 'hasPrimaryAddress';
export const Label: LabelFilterComponent = () => 'Primary address';

export const Icon: FilterIcon = faStar;

export const Filter: ContentFilterComponent = () => {
    const { defaultValue, ...rest } = useFilter<string>();
    const methods = Form.useForm<PrimaryAddressFilterFormValues>({
        defaultValues: {
            value: defaultValue ? defaultValue.value : '',
        },
        mode: 'onChange',
    });
    const { control, path } = methods;

    const ctx = useMemo(
        () => ({
            defaultValue,
            ...rest,
        }),
        [defaultValue, rest],
    );

    return (
        <FilterFormContext.Provider value={ctx}>
            <Form.Provider {...methods}>
                <FilterForm>
                    <FilterContainer>
                        <Form.Container>
                            <Form.Label name={path('value')}>Has primary address</Form.Label>
                            <Form.Switch name={path('value')} control={control} />
                            <Form.Error name={path('value')} />
                        </Form.Container>
                        <FilterSubmit />
                    </FilterContainer>
                </FilterForm>
            </Form.Provider>
        </FilterFormContext.Provider>
    );
};

export const Readable: ReadableFilterComponent = () => {
    const currentFilter = useCurrentFilter<string>();
    const value = currentFilter?.value ?? '';

    return <ReadableFilterValue>{value ? 'not empty' : 'empty'}</ReadableFilterValue>;
};

export const downstream: DownstreamFilterTransform<string> = identity;

export const upstream: UpstreamFilterTransform<string> = (filter: FilterValue) => {
    return {
        value: filter.value ? 'has' : 'doesnt_have',
    };
};
